import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const DashboardServiceConfig = {
  name: "Dashboard",
  annotations: []
} as ServiceConfig;